import FirestoreModel from './FirestoreModel'

class CouponPool extends FirestoreModel {
  collectionName = 'couponPools'
  constructor(firebase) {
    super(firebase)
    this.setCollection(this.collectionName)
  }
}

export default CouponPool
